import { getImageUrl } from '../../../utils/getImageUrl';
import SignatureCEO from '../assets/evaluation/signature-ceo.png';

// Nilai default kalau admin belum pernah mengatur config untuk batch
// tersebut (mis. batch 1-4 sebelum fitur ini dipakai) -- meniru persis nilai
// hardcode lama supaya PDF batch lama tidak berubah.
export const FALLBACK_EVAL_SIGNATURE = SignatureCEO;

// Field antara endpoint siswa (CLPGetMyFinalEvaluationsDetailUseCase) dan
// admin/mentor (CLPGetEvaluationsDetailUseCase) tidak seragam namanya
// (evaluationsHS vs evaluationsKPI, attendance vs attendanceMetrics, dst).
// Normalizer ini menyeragamkannya supaya FormulaV1Template/FormulaV2Template
// bisa dipakai oleh kedua halaman tanpa cabang logic.
export const normalizeFinalEvaluationData = (data = {}) => {
  const evaluationsHS = data.evaluationsHS || data.evaluationsKPI || [];
  const patScore = data.evaluationsPAT?.finalEvaluationAverage
    ?? data.patProgressMetrics?.finalEvaluationAverage
    ?? null;
  const attendanceScore = data.attendance?.score ?? data.attendanceMetrics?.score ?? null;

  return {
    ...data,
    evaluationsHS,
    patScore,
    attendanceScore,
  };
};

export const resolveImageSrc = (url, fallback) => {
  if (!url) return fallback;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  return getImageUrl(url);
};

export const formatDocDate = (place, dateValue, fallbackText) => {
  if (!dateValue) return fallbackText;

  const date = new Date(dateValue);
  const formatted = date.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return `${place || 'Jakarta'}, ${formatted}`;
};
